import { AfterViewInit, Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';

export interface ProgressAnimationDialogData {
	title?: string;
	showClose: boolean | 'auto';
	progressMessage?: ((response: any) => string) | string;
	successMessage?: ((response: any) => string) | string;
	failureMessage?: ((response: any) => string) | string;

	successIcon?: string;
	failureIcon?: string;
	query: Observable<any>;
	statusChecker: ((response: any) => boolean);

	successButtonText?: string;
	failureButtonText?: string;
	backButtonText?: string;

	autoClose?: boolean;
	autoCloseDelay?: number;

}

/**
 * A dialog that shows an animation while a query is in progress
 */


@Component({
	selector: 'app-query-animation-dialog',
	templateUrl: './query-animation-dialog.component.html',
	styleUrls: ['./query-animation-dialog.component.scss']
})
export class QueryAnimationDialogComponent implements AfterViewInit {

	querying: boolean | undefined = undefined;
	isSuccess = false;
	queryResponse: any;
	responseStatusChecker = ((response) => response.status === 'succeeded');

	constructor(
		public dialogRef: MatDialogRef<QueryAnimationDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: ProgressAnimationDialogData) {

		if (this.data.statusChecker) {
			this.responseStatusChecker = this.data.statusChecker;
		}


	}

	ngAfterViewInit() {
		if (this.data.query === undefined) {
			this.isSuccess = false;
			this.querying = false;
			return;
		}

		// start the query
		this.querying = true;
		this.data.query.pipe(
			catchError(err => of(err))
		).subscribe(response => {
			this.queryResponse = response;
			this.isSuccess = this.responseStatusChecker(response);
			this.querying = false;

			if (this.isSuccess) {
				this.checkForAutoClose();
			}
		});
	}

	getMessage(settings: ProgressAnimationDialogData, queryInProgress: boolean, isSuccess: boolean, queryResponse: any): string | undefined {


		if (queryInProgress) {
			return typeof settings.progressMessage === 'function' ? settings.progressMessage(queryResponse) : settings.progressMessage;
		}

		if (isSuccess) {
			return typeof settings.successMessage === 'function' ? settings.successMessage(queryResponse) : settings.successMessage;
		}

		return typeof settings.failureMessage === 'function' ? settings.failureMessage(queryResponse) : settings.failureMessage;

	}

	checkForAutoClose(): void {
		if (this.data.autoClose && this.dialogRef) {
			setTimeout(() => {
				this.dialogRef.close();
			}, this.data.autoCloseDelay || 100);
		}

	}
}
